import {
    PRIVACY_LEAFLET_MORE_INFO,
    PRIVACY_LEAFLET_OK,
    PRIVACY_LEAFLET_ONE_LINER,
} from 'mk/autogenerated/translations/PrivacyReminder.135e6dfddf58cfcf76e5103fd715e1bf'
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { about_privacy_and_cookie_policy_url, about_privacy_leaflet_url } from 'mk/urls/functions';
import { BtnType, default as Btn } from 'mk2/components/Btn';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import * as React from 'react';
import styles from './PrivacyReminder.mscss';

interface OwnProps {
    currentUrl: string;
    showPrivacyReminder: boolean;
    fluxibleCompatibility: boolean;
    onPrivacyLeafletAccept();
}

class PrivacyReminder extends React.Component<OwnProps> {

    public componentDidMount() {
        if (this.props.showPrivacyReminder) {
            document.body.classList.add('has-privacy-reminder');
        }
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.showPrivacyReminder !== this.props.showPrivacyReminder) {
            if (this.props.showPrivacyReminder) {
                document.body.classList.add('has-privacy-reminder');
            } else {
                document.body.classList.remove('has-privacy-reminder');
            }
        }
    }

    public componentWillUnmount() {
        document.body.classList.remove('has-privacy-reminder');
    }

    public render() {
        const {
            currentUrl, showPrivacyReminder, onPrivacyLeafletAccept, fluxibleCompatibility,
        } = this.props;

        return showPrivacyReminder ? (
            <div className={styles.PrivacyReminder}>
                {PRIVACY_LEAFLET_ONE_LINER}
                &nbsp;
                <CompatibleLink
                    fluxibleCompatibility={fluxibleCompatibility}
                    to={ACTIVE_SERVER_ID !== 207
                        ? about_privacy_leaflet_url({next: encodeURIComponent(currentUrl)})
                        : about_privacy_and_cookie_policy_url({next: encodeURIComponent(currentUrl)})}
                    rel="nofollow"
                >
                    {PRIVACY_LEAFLET_MORE_INFO}
                </CompatibleLink>
                &nbsp;
                <Btn
                    type={BtnType.Blue}
                    label={PRIVACY_LEAFLET_OK}
                    classNames={{label : styles.PrivacyReminder__btnLabel}}
                    onClick={onPrivacyLeafletAccept}
                />
            </div>
        ) : null;
    }
}

export default PrivacyReminder;
